// import { apiClient } from "../client";

import { apiClient } from '../client';

// export const chatService = {
//   sendPrompt: async (prompt: string) => {
//     const { data } = await apiClient.post(`/ai/analyze`, { prompt });
//     return data;
//   },
//   //   future refrence
//   getChatList: async () => {
//     const { data } = await apiClient.get(`/chat/list`);
//     return data;
//   },
//   getChatHistory: async (userId: string) => {
//     const { data } = await apiClient.get(`/chat/history/${userId}`);
//     return data;
//   },
//   getChatMessages: async (userId: string) => {
//     const { data } = await apiClient.get(`/chat/messages/${userId}`);
//     return data;
//   },
//   deleteMessage: async (messageId: string) => {
//     const { data } = await apiClient.delete(`/chat/delete/${messageId}`);
//     return data;
//   },
// };

// services/chatService.ts

export interface ConversationItem {
  id: string;
  title: string;
  createdAt: string;
}

export interface MessageHistory {
  toolInvocations: never[];
  id: string;
  conversationId: string;
  role: 'user' | 'assistant';
  content: string;
  parts: Array<{
    type: string;
    text: string;
  }>;
  createdAt: string;
}

export interface ChatStreamRequest {
  conversationId: string | null;
  id: string;
  messages: Array<{
    conversationId: string | null;
    role: 'user' | 'assistant';
    content: string;
    parts: Array<{
      type: string;
      text: string;
    }>;
  }>;
  systemMessage: string;
  temperature: number;
  profileIds?: string[];
  startDate?: string;
  endDate?: string;
  compareStartDate?: string;
  compareEndDate?: string;
  advertiserIds?: string[];
  timezoneOffset?: number;
}

export interface CreateConversationRequest {
  title: string;
}

export interface SaveMessageRequest {
  conversationId: string;
  role: 'user' | 'assistant';
  content: string;
  parts: Array<{
    type: string;
    text: string;
  }>;
}

export const chatService = {
  // Get all conversations
  getConversations: async (): Promise<ConversationItem[]> => {
    const { data } = await apiClient.get('/ai/conversations');
    return data.map((conv: any) => ({
      id: conv.id || conv._id,
      title: conv.title || conv.name || 'Untitled Conversation',
      createdAt: conv.createdAt || conv.created_at,
    }));
  },

  // Get conversation by ID with messages
  getConversation: async (
    conversationId: string
  ): Promise<{
    conversation: ConversationItem;
    messages: MessageHistory[];
  }> => {
    const { data } = await apiClient.get(`/ai/conversations/${conversationId}`);
    return {
      conversation: {
        id: data.id || data._id,
        title: data.title || data.name || 'Untitled Conversation',
        createdAt: data.createdAt || data.created_at,
      },
      messages: data.messages || [],
    };
  },

  // Create new conversation
  createConversation: async (
    request: CreateConversationRequest
  ): Promise<ConversationItem> => {
    const { data } = await apiClient.post('/ai/conversations', request);
    return {
      id: data.id || data._id,
      title: data.title || data.name || 'Untitled Conversation',
      createdAt: data.createdAt || data.created_at,
    };
  },

  // Delete conversation
  deleteConversation: async (conversationId: string): Promise<void> => {
    const { data } = await apiClient.delete(
      `/ai/conversations/${conversationId}`
    );
    return data;
  },

  // Save message to conversation
  saveMessage: async (request: SaveMessageRequest): Promise<MessageHistory> => {
    const { data } = await apiClient.post(
      `/ai/conversations/${request.conversationId}/messages`,
      request
    );
    return data;
  },

  // Stream chat (for custom fetch in useChat)
  streamChat: async (url: string, options: RequestInit): Promise<Response> => {
    const body = JSON.parse(options.body as string);

    const transformedBody: ChatStreamRequest = {
      conversationId: body.conversationId || null,
      id: body.id,
      messages: body.messages.map((msg: any) => ({
        conversationId: body.conversationId || null,
        role: msg.role,
        content: msg.content,
        parts: [
          {
            type: 'text',
            text: msg.content,
          },
        ],
      })),
      systemMessage:
        'You are Sellco AI, a helpful assistant for sales and business inquiries.',
      temperature: 0.7,
      profileIds: body.profileIds,
      startDate: body.startDate,
      endDate: body.endDate,
      compareStartDate: body.compareStartDate,
      compareEndDate: body.compareEndDate,
      advertiserIds: body.advertiserIds,
      timezoneOffset: body.timezoneOffset
    };

    return fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(transformedBody),
    });
  },

  // Send prompt (for analysis)
  sendPrompt: async (prompt: string) => {
    const { data } = await apiClient.post('/ai/analyze', { prompt });
    return data;
  },

  // Update conversation title
  updateConversation: async (
    conversationId: string,
    title: string
  ): Promise<ConversationItem> => {
    const { data } = await apiClient.put(
      `/ai/conversations/${conversationId}`,
      { title }
    );
    return {
      id: data.id || data._id,
      title: data.title || data.name || 'Untitled Conversation',
      createdAt: data.createdAt || data.created_at,
    };
  },
};
